import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "番剧检索", to: "/sousuo" },
  { label: "高口碑榜单", to: "/#ranking" },
  { label: "隐藏目录", to: "/#secret" },
  { label: "关于我们", to: "/guanyu" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-8">
        <Link to="/" className="group flex items-center gap-2.5 whitespace-nowrap" aria-label="牛奶动漫库首页">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full transition-colors ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
            }`}
          >
            <i className="ri-cup-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl font-bold tracking-wide transition-colors ${
              scrolled ? "text-foreground-900" : "text-background-50"
            }`}
          >
            牛奶动漫库
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              className={`whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                  : "text-background-50/90 hover:bg-background-50/10 hover:text-background-50"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/sousuo"
            className="ml-3 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-search-line"></i>
            去检索
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
            scrolled ? "text-foreground-900" : "text-background-50"
          }`}
          aria-label="切换菜单"
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-4">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                onClick={() => setOpen(false)}
                className="rounded-md px-4 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}